import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const HeaderSection = ({
	title,
	description,
}: {
	title: string;
	description?: {
		registDt?: string;
		updateDt?: string;
	};
}) => {
	const { t } = useTranslation('common');
	return (
		<div className="h-[60px] row-between p-5 border-b">
			<span className="text-base text-font2 font-bold leading-[20px]">
				{title}
			</span>
			{description && (
				<div className="text-[13px] text-font6 leading-[15.51px]">
					{description?.registDt && (
						<span>
							{t('registration-date')}: {description.registDt}
						</span>
					)}
					{description?.updateDt && (
						<span className="ml-3">
							{t('modified-date')}: {description.updateDt}
						</span>
					)}
				</div>
			)}
		</div>
	);
};

export default memo(HeaderSection);
